import { authRequest, AuthenticationPurpose } from './api.ts';

type AuthenticationCompletion = {
    redirect?: string | null;
};

export type AuthenticationAdapter = {
    complete: (grant: string, purpose: AuthenticationPurpose) => Promise<AuthenticationCompletion>;
};

let authenticationAdapter: AuthenticationAdapter = {
    complete: (grant, purpose) =>
        authRequest<AuthenticationCompletion>('grants/session', 'POST', { grant, purpose }),
};

export function provideAuthenticationAdapter(adapter: AuthenticationAdapter) {
    authenticationAdapter = adapter;
}

export function useAuthenticationAdapter() {
    return authenticationAdapter;
}
